import { render, staticRenderFns } from "./InformationView.vue?vue&type=template&id=0aa145bc&scoped=true"
import script from "./InformationView.vue?vue&type=script&lang=js"
export * from "./InformationView.vue?vue&type=script&lang=js"
import style0 from "./InformationView.vue?vue&type=style&index=0&id=0aa145bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa145bc",
  null
  
)

export default component.exports